module.exports = __webpack_public_path__ + "img/blue.6b341492.svg";